import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { getIcon, getRatingAverage } from "../../utils";
import { getProperty } from "../../services/properties";
import { getPropertyUnit } from "../../services/units";
import Card from "../../components/Card";
import { ROUTES } from "../../constants";

function ListingCard({ listing }) {
  const [property, setProperty] = useState();
  const [unit, setUnit] = useState();
  const rating = getRatingAverage(listing.ratings);

  useEffect(() => {
    if (listing.propertyId) {
      getProperty(listing.propertyId).then((response) => {
        setProperty(response);
      });
      if (listing.unitId) {
        getPropertyUnit(listing.propertyId, listing.unitId).then((response) => {
          setUnit(response);
        });
      }
    }
  }, [listing.propertyId, listing.unitId]);

  const getStars = (ratingCount) => {
    let n = 0;
    const result = [];
    while (n < ratingCount) {
      n++;
      result.push("");
    }
    return <>{result?.map((item, index) => getIcon("STAR", index))}</>;
  };

  let title = "";
  if (property) {
    title = `${property.address.street}, ${property.address.city}, ${property.address.subdivision}, ${property.address.country} ${property.address.postalCode}`;
  }

  return (
    <Card
      prepertyId={listing}
      to={`${ROUTES.PRIVATE_LISTINGS}/${listing.id}`}
      title={title}
      photoUrl={listing?.photoUrls[0]}
      style={{ position: "relative" }}
      actions={
        <Grid style={{ bottom: "1rem" }} container>
          {getStars(rating)}
        </Grid>
      }
    />
  );
}

export default ListingCard;
